<template>
  <div>
    <ThePageHeader
      :title="subService.title"
      :parent-route="{ title: service.title, slug: service.slug }"
    />

    <div
      class="text"
      v-html="subService.longText || subService.text"
    />

    <div class="mt-5 text-xs-center">
      <img
        :src="require(`@/assets/service-photos/${subService.slug}.jpg`)"
        style="width: 1000px; max-width: calc(100vw - 32px);"
        :alt="subService.title"
      >
    </div>
  </div>
</template>

<script>
import ThePageHeader from '@/components/ThePageHeader.vue';
import servicesData from '@/data/services.json';

export default {
  name: 'SubServices',
  components: {
    ThePageHeader,
  },
  metaInfo() {
    const { title, text } = this.subService;

    return {
      title: `${title} | Körös PRINT-PACK Kft.`,
      meta: [
        {
          name: 'description',
          content: text && text.length > 117 ? `${text.slice(0, 116)}...` : text,
        },
      ],
    };
  },
  data: () => ({
    services: servicesData,
  }),
  computed: {
    service() {
      const { serviceSlug } = this.$route.params;

      const service = this.services.find(({ slug }) => slug === serviceSlug);

      if (!service) {
        this.$router.replace({ name: 'Services', params: { slug: 'dobozgyartas' } });
        return {};
      }

      return service;
    },
    subService() {
      const { subServiceSlug } = this.$route.params;

      const subServices = this.service.subServices || [];
      const subService = subServices.find(({ slug }) => slug === subServiceSlug);

      if (!subService) {
        this.$router.replace({ name: 'Services', params: { slug: 'dobozgyartas' } });
        return {};
      }

      return subService;
    },
  },
};
</script>

<style scoped>
.text {
  margin: 100px auto 0 auto;
  width: 1000px;
  max-width: 90vw;
  font-size: 18px;
  color: #757575;
  line-height: 1.8;
}
</style>
